import { render, staticRenderFns } from "./ResumeEdit.vue?vue&type=template&id=0b521dd8&"
import script from "./ResumeEdit.vue?vue&type=script&lang=js&"
export * from "./ResumeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports